import queryString from "query-string";
import {
  GET_LIST,
  GET_DETAIL,
  GET_LOGS,
  CREATE_DATA,
  REMOVE_DATA,
  UPDATE_DATA,
} from "../../api/mylink/mylink";

const state = {
  list: [],
  detail: null,
};

const mutations = {
  SET_LIST: (states, payload) => {
    states.list = payload;
  },
  SET_DETAIL: (states, payload) => {
    states.detail = payload;
  },
};

const actions = {
  GET_LIST: ({ commit }, query) => {
    return GET_LIST(query);
  },
  GET_DETAIL: ({ commit }, payload) => {
    return GET_DETAIL(payload);
  },
  GET_LOGS: ({ commit }, payload) => {
    return GET_LOGS(payload);
  },
  CREATE_DATA: ({}, payload) => {
    return CREATE_DATA(payload);
  },
  UPDATE_DATA: ({}, { id, payload }) => {
    return UPDATE_DATA(id, payload);
  },
  REMOVE_DATA: ({}, id) => {
    return REMOVE_DATA(id);
  },
};

const getters = {
  list: (states) => states.list,
  detail: (states) => states.detail,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
